const kirbyFlexImg = require('../../assets/images/workouts/kirby.jpeg');
const sonicSpeedImg = require('../../assets/images/workouts/sonic.jpeg');
const genjiHandsImg = require('../../assets/images/workouts/genji.jpeg');
const kratosCritsImg = require('../../assets/images/workouts/kratos.jpeg');
const hammerDownImg = require('../../assets/images/workouts/hammerdown.jpeg');
const ganonCannonsImg = require('../../assets/images/workouts/ganoncannon.jpeg');
const masterChiefImg = require('../../assets/images/workouts/masterchief.jpeg');
const tombRaiderImg = require('../../assets/images/workouts/tombraider.jpeg');
const endlessScrollerImg = require('../../assets/images/workouts/endlessscroll.jpeg');
const experienceTranquilityImg = require('../../assets/images/workouts/experiencetranquility.jpeg');
const theMedicImg = require('../../assets/images/workouts/themedic.jpeg');
const valhallaImg = require('../../assets/images/workouts/mercy.jpeg');
const endermanImg = require('../../assets/images/workouts/enderman.jpeg');
const misterFantasticImg = require('../../assets/images/workouts/mrfantastic.jpeg');
const waveDashImg = require('../../assets/images/workouts/wavedash.jpeg');
const fullCounterImg = require('../../assets/images/workouts/fullcounter.jpeg');
const evasiveStrikeImg = require('../../assets/images/workouts/evasivestrike.jpeg');
const plasticManImg = require('../../assets/images/workouts/plasticman.jpeg');
const hulkSmashImg = require('../../assets/images/workouts/hulksmash.jpeg');
const keySmasherImg = require('../../assets/images/workouts/keysmash.jpeg');
const juggernaughtImg = require('../../assets/images/workouts/jugg.jpeg');
const masterSwordImg = require('../../assets/images/workouts/master.jpeg');
const superNovaImg = require('../../assets/images/workouts/nova.jpeg');
const forcePushImg = require('../../assets/images/workouts/push.jpeg');
const theGulagImg = require('../../assets/images/workouts/gulag.jpeg');
const darkSoulsImg = require('../../assets/images/workouts/darksouls.jpeg');
const circleClosingInImg = require('../../assets/images/workouts/circle.jpeg');
const killStreakImg = require('../../assets/images/workouts/killstreak.jpeg');
const rainbowRoadImg = require('../../assets/images/workouts/rainbowroad.jpeg');
const pacManImg = require('../../assets/images/workouts/pacman.jpeg');
const medKitImg = require('../../assets/images/workouts/medkit.jpeg');
const quickReviveImg = require('../../assets/images/workouts/quickrevive.jpeg');
const pokeCenterImg = require('../../assets/images/workouts/poke.jpeg');
const painKillersImg = require('../../assets/images/workouts/painkillers.jpeg');
const nukaColaImg = require('../../assets/images/workouts/nuka.jpeg');
const heartContainerImg = require('../../assets/images/workouts/heartcontainer.jpeg');

const WorkoutImages = {
  KirbyFlex: kirbyFlexImg,
  SonicSpeed: sonicSpeedImg,
  GenjiHands: genjiHandsImg,
  KratosCrits: kratosCritsImg,
  HammerDown: hammerDownImg,
  GanonCannons: ganonCannonsImg,
  MasterChief: masterChiefImg,
  TombRaider: tombRaiderImg,
  EndlessScroller: endlessScrollerImg,
  ExperienceTranquility: experienceTranquilityImg,
  TheMedic: theMedicImg,
  Valhalla: valhallaImg,
  Enderman: endermanImg,
  MisterFantastic: misterFantasticImg,
  WaveDash: waveDashImg,
  FullCounter: fullCounterImg,
  EvasiveStrike: evasiveStrikeImg,
  PlasticMan: plasticManImg,
  HulkSmash: hulkSmashImg,
  KeySmasher: keySmasherImg,
  Juggernaught: juggernaughtImg,
  MasterSword: masterSwordImg,
  SuperNova: superNovaImg,
  ForcePush: forcePushImg,
  TheGulag: theGulagImg,
  DarkSouls: darkSoulsImg,
  CircleClosingIn: circleClosingInImg,
  KillStreak: killStreakImg,
  RainbowRoad: rainbowRoadImg,
  PacMan: pacManImg,
  MedKit: medKitImg,
  QuickRevive: quickReviveImg,
  PokeCenter: pokeCenterImg,
  PainKillers: painKillersImg,
  NukaCola: nukaColaImg,
  HeartContainer: heartContainerImg,
};

export default WorkoutImages;
